<div class="host-content">
    <slot-manager
        *ngIf="contentSwitch.isContentAVisible"
        [element]="element.children['slot-nav-a'] ?? element.children[0]"
        [direction]="direction"
        [resolution]="resolution"
        [hasLogoSections]="hasLogoSections"
    >
    </slot-manager>
    <slot-manager
        *ngIf="contentSwitch.isContentBVisible"
        [element]="element.children['slot-nav-b'] ?? element.children[1]"
        [direction]="direction"
        [resolution]="resolution"
        [hasLogoSections]="hasLogoSections"
    >
    </slot-manager>
</div>
